module.exports = __webpack_public_path__ + "img/1.6c1f7e9a.jpg";